__turbopack_context__.v({
  "accommodationTab": "page-module__fm_3ha__accommodationTab",
  "content": "page-module__fm_3ha__content",
  "page": "page-module__fm_3ha__page",
  "tabContentIn": "page-module__fm_3ha__tabContentIn",
  "tabContentSwap": "page-module__fm_3ha__tabContentSwap",
});
